import { render, staticRenderFns } from "./viewForm.vue?vue&type=template&id=70bc579a&"
import script from "./viewForm.vue?vue&type=script&lang=js&"
export * from "./viewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports